import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../../services/api';

const CMSOrderDetail = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const res = await api.getEcommerceOrderById(id);
        if (res.success) setOrder(res.data);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) return <div className="text-center p-4">Loading...</div>;
  if (error) {
    return (
      <div className="alert alert-danger">
        {error}
        <Link to="/cms/orders" className="btn btn-sm btn-default ml-2">Back to Orders</Link>
      </div>
    );
  }
  if (!order) return <div className="text-center p-4">Order not found</div>;

  const items = order.items || [];

  return (
    <>
      <div className="row mb-3">
        <div className="col-md-12">
          <Link to="/cms/orders" className="btn btn-default btn-sm">
            <i className="fas fa-arrow-left"></i> Back to Orders
          </Link>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Order</h3>
              <span className="badge bg-secondary">{order.status}</span>
            </div>
            <div className="card-body">
              <p><strong>Order ID:</strong> {order.id}</p>
              <p><strong>Order number:</strong> <code>{order.order_number}</code></p>
              <p><strong>Created:</strong> {order.created_at ? new Date(order.created_at).toLocaleString() : '—'}</p>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Customer</h3>
            </div>
            <div className="card-body">
              <p><strong>Name:</strong> {order.customer_name}</p>
              <p><strong>Email:</strong> {order.customer_email}</p>
              <p><strong>Phone:</strong> {order.customer_phone || '—'}</p>
              {order.shipping_address && (
                <p><strong>Shipping address:</strong><br />{order.shipping_address}</p>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Products ordered</h3>
        </div>
        <div className="card-body p-0">
          <table className="table table-bordered mb-0">
            <thead>
              <tr>
                <th>Product</th>
                <th>SKU</th>
                <th>Qty</th>
                <th>Unit price</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center">No items</td>
                </tr>
              ) : (
                items.map((item) => (
                  <tr key={item.id}>
                    <td>{item.product_name}</td>
                    <td><code>{item.sku || '—'}</code></td>
                    <td>{item.quantity}</td>
                    <td>{Number(item.unit_price).toFixed(2)}</td>
                    <td>{Number(item.total).toFixed(2)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className="card-footer">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6 text-right">
              <p className="mb-0"><strong>Subtotal:</strong> {Number(order.subtotal).toFixed(2)}</p>
              {order.tax != null && Number(order.tax) !== 0 && (
                <p className="mb-0"><strong>Tax:</strong> {Number(order.tax).toFixed(2)}</p>
              )}
              <p className="mb-0"><strong>Total:</strong> {Number(order.total).toFixed(2)}</p>
            </div>
          </div>
        </div>
      </div>

      {order.notes && (
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Notes</h3>
          </div>
          <div className="card-body">
            <p className="mb-0">{order.notes}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default CMSOrderDetail;
